import { useEffect, useState } from "react";

import Table from "../components/Table";
import Modal from "../components/Modal";
import Form from "../components/Form";
import ModalAsignar from "../components/ModalAsignar";
import ModalAsignacionesTarjeta from '../components/ModalAsignacionesTarjeta';
const API_URL = process.env.REACT_APP_API_URL;
const ESTADO_INICIAL = {
    numero_tarjeta: '', fecha_vencimiento: null, estado: '', observaciones: '', sucursal_id: 'null', area_id: 'null',
};

export default function TarjetasScreen({ currentUser, token }) {
    const isAdmin = currentUser?.rol === 'admin';
    const isGerente = currentUser?.rol === 'gerente';
    const isCelular = currentUser?.rol === 'celular';
    const [tarjetas, setTarjetas] = useState([]);
    const [sucursales, setSucursales] = useState([]);
    const [areas, setAreas] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [usuarioId, setUsuarioId] = useState('');
    const [loading, setLoading] = useState(true);
    const [tarjetaForm, setTarjetaForm] = useState(ESTADO_INICIAL);
    const [tarjetaAsignar, setTarjetaAsignar] = useState(null);
    const [mendelToken, setMendelToken] = useState('');
    const [showMendel, setShowMendel] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [tarjetaDetalle, setTarjetaDetalle] = useState(null);
    const [asignaciones, setAsignaciones] = useState([]);
    const [modal, setModal] = useState({ visible: false, titulo: '', mensaje: '', tipo: 'info', onConfirm: null });
    const set = (campo) => (v) => setTarjetaForm(f => ({ ...f, [campo]: v }));
    const showModal = (tipo, titulo, mensaje, onConfirm = null) =>
        setModal({ visible: true, tipo, titulo, mensaje, onConfirm });

    const cargar = async () => {
        setLoading(true);
        try {
            const [resT, resS, resA, resU] = await Promise.all([
                fetch(`${API_URL}/tarjetas`, { headers: { Authorization: `Bearer ${token}` } }),
                fetch(`${API_URL}/sucursales`, { headers: { Authorization: `Bearer ${token}` } }),
                fetch(`${API_URL}/areas`, { headers: { Authorization: `Bearer ${token}` } }),
                fetch(`${API_URL}/usuarios`, { headers: { Authorization: `Bearer ${token}` } }),
            ]);
            setTarjetas(await resT.json());
            setSucursales(await resS.json());
            setAreas(await resA.json());
            setUsuarios(await resU.json());
        } catch {
            showModal("error", "Error", "No se pudieron cargar los datos");
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => { cargar(); }, []);

    const abrirNuevo = () => {
        setTarjetaForm(ESTADO_INICIAL);
        setShowForm(true);
    };
    const cerrarForm = () => {
        setShowForm(false);
        setTarjetaForm(ESTADO_INICIAL);
    };
    const abrirEditar = (row) => {
        setTarjetaForm({
            ...ESTADO_INICIAL,
            ...row,
            fecha_vencimiento: row.fecha_vencimiento
                ? row.fecha_vencimiento.split('T')[0]
                : null
        });
        setShowForm(true);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    const abrirAsignar = (row) => {
        setTarjetaAsignar(row);
        setUsuarioId('');
    };
    const cerrarAsignar = () => {
        setTarjetaAsignar(null);
        setUsuarioId('');
    };
    const abrirDetalle = async (row) => {
        try {
            const res = await fetch(`${API_URL}/tarjetas/${row.id}/asignaciones`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const data = await res.json().catch(() => []);
            setAsignaciones(Array.isArray(data) ? data : []);
            setTarjetaDetalle(row);
        } catch {
            showModal('error', 'Error', 'No se pudieron cargar las asignaciones');
        }
    };
    const cerrarDetalle = () => {
        setTarjetaDetalle(null); setAsignaciones([]);

    };
    const handleGuardar = async (e) => {
        e.preventDefault();
        try {
            const esEdicion = !!tarjetaForm.id;
            const res = await fetch(
                esEdicion ? `${API_URL}/tarjetas/${tarjetaForm.id}` : `${API_URL}/tarjetas`,
                {
                    method: esEdicion ? 'PUT' : 'POST',
                    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                    body: JSON.stringify(tarjetaForm)
                }
            );
            const data = await res.json().catch(() => ({}));
            if (!res.ok) throw new Error(data.message);
            cerrarForm();
            cargar();
            showModal('success', 'Listo', esEdicion ? 'Tarjeta actualizada' : 'Tarjeta creada');
        } catch (err) {
            showModal('error', 'Error en catch handle guardar', err.message);
        }
    };
    const handleAsignar = async (e) => {
        e.preventDefault();
        try {
            const res = await fetch(`${API_URL}/tarjetas/asignar`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                body: JSON.stringify({ usuario_id: usuarioId, tarjeta_id: tarjetaAsignar.id })
            });
            const data = await res.json().catch(() => ({}));
            if (!res.ok) throw new Error(data.message);
            cerrarAsignar();
            cargar();
            showModal('success', 'Listo', 'Tarjeta asignada correctamente');
        } catch (err) {
            showModal('error', 'Error', err.message);
        }
    };
    const handleDesasignar = (row) => {
        showModal('confirm', '¿Desasignar tarjeta?',
            `Se desasignará la tarjeta **** ${row.numero_tarjeta?.slice(-4)}`,
            async () => {
                try {
                    const res = await fetch(`${API_URL}/tarjetas/desasignar`, {
                        method: 'PUT',
                        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                        body: JSON.stringify({ tarjeta_id: row.id })
                    });
                    const data = await res.json().catch(() => ({}));
                    if (!res.ok) throw new Error(data.message);
                    cargar();
                    showModal('success', 'Listo', 'Tarjeta desasignada');
                } catch (err) {
                    showModal('error', 'Error', err.message);
                }
            }
        );
    };
    const handleDescargar = async (asignacion) => {
        try {
            console.log('Descargando asignacion:', asignacion.id);
            const res = await fetch(`${API_URL}/tarjetas/responsiva/${asignacion.id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            console.log('Status:', res.status);
            if (!res.ok) {
                const err = await res.json().catch(() => ({}));
                throw new Error(err.message ?? `Error ${res.status}`);
            }
            const blob = await res.blob();
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url; a.download = `responsiva_tarjeta_${asignacion.id}.pdf`; a.click();
            URL.revokeObjectURL(url);
        } catch (err) {
            console.error('Error descarga:', err);
            showModal('error', 'Error', err.message);
        }
    };

    const handleSubirFirmada = async (asignacion, archivo) => {
        const formData = new FormData();
        formData.append('responsiva', archivo);
        try {
            const res = await fetch(`${API_URL}/tarjetas/responsiva/${asignacion.id}/firmar`, {
                method: 'PUT',
                headers: { Authorization: `Bearer ${token}` },
                body: formData
            });
            const data = await res.json().catch(() => ({}));
            if (!res.ok) throw new Error(data.message);
            abrirDetalle(tarjetaDetalle); // recarga el historial
            showModal('success', 'Listo', 'Responsiva firmada subida');
        } catch (err) {
            showModal('error', 'Error', err.message);
        }
    };
    const handleSincronizar = async (e) => {
        e.preventDefault();
        try {
            const res = await fetch(`${API_URL}/tarjetas/sincronizar`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                body: JSON.stringify({ mendel_token: mendelToken })
            });
            const data = await res.json().catch(() => ({}));
            if (!res.ok) throw new Error(data.message);
            setShowMendel(false);
            setMendelToken('');
            cargar();
            showModal('success', 'Sincronización completa',
                `${data.nuevas} tarjetas nuevas, ${data.eliminadas} eliminadas`);
        } catch (err) {
            showModal('error', 'Error', err.message);
        }
    };

    const columnas = [
        { header: 'Numero de tarjeta', accessor: 'numero_tarjeta' },
        { header: 'Fecha de vencimiento', render: (row) => row.fecha_vencimiento.split('T')[0] },
        { header: 'Estado', accessor: 'estado' },
        { header: 'Observaciones', accessor: 'observaciones' },
        { header: 'Sucursal', render: (row) => sucursales.find(s => s.id === row.sucursal_id)?.nombre ?? '—' },
        { header: 'Área', render: (row) => areas.find(a => a.id === row.area_id)?.nombre ?? '—' },
        ...((isAdmin || isGerente || isCelular) ? [{
            header: 'Acciones', render: (row) => (
                <>
                    {isAdmin && <button className="btn-edit" onClick={() => abrirEditar(row)}>Editar</button>}
                    <button className="btn-edit" style={{ background: '#17a2b8', color: 'white' }}
                        onClick={() => abrirDetalle(row)}>Historial</button>
                    {(isAdmin || isGerente) && row.estado === 'Disponible' && (
                        <button className="btn-edit" style={{ background: '#28a745', color: 'white' }}
                            onClick={() => abrirAsignar(row)}>Asignar</button>
                    )}
                    {(isAdmin || isGerente) && row.estado === 'Asignada' && (
                        <button className="btn-delete" 
                            onClick={() => handleDesasignar(row)}>Desasignar</button>
                    )}
                </>
            )
        }] : []),
    ];
    // ── Config form ───────────────────────────────────────────────────────
    const campos = [
        { label: 'Numero de tarjeta', value: tarjetaForm.numero_tarjeta, onChange: set('numero_tarjeta'), required: true, placeholder: 'Numero de tarjeta' },
        { label: 'Fecha de vencimiento', type: 'date', value: tarjetaForm.fecha_vencimiento, onChange: set('fecha_vencimiento'), required: true },
        { label: 'Estado', type: 'select', value: tarjetaForm.estado, onChange: set('estado'), required: true, options: ['Disponible', 'Asignada', 'Bloqueada', 'Otra'] },
        { label: 'Observaciones', value: tarjetaForm.observaciones, onChange: set('observaciones'), placeholder: 'Observaciones' },
        { label: 'Sucursal', type: 'select', value: tarjetaForm.sucursal_id, onChange: set('sucursal_id'), required: true, options: [{ value: '', label: '-- Selecciona --' }, ...sucursales.map(s => ({ value: s.id, label: s.nombre }))] },
        {
            label: 'Área', type: 'select', value: tarjetaForm.area_id, onChange: set('area_id'), required: true, options: [
                { value: '', label: '-- Selecciona --' },
                ...areas.map(a => ({
                    value: a.id,
                    label: `${sucursales.find(s => s.id === a.sucursal_id)?.nombre ?? '?'} - ${a.nombre}`
                }))
            ]
        },
    ];
    if (loading) return <p>Cargando...</p>;
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <h2>Tarjetas</h2>
                {isAdmin && (
                    <>
                        <button className="btn-secondary" onClick={showForm ? cerrarForm : abrirNuevo}>
                            {showForm ? 'Cancelar' : 'Nueva Tarjeta'}
                        </button>

                        <button className="btn-primary" onClick={() => setShowMendel(s => !s)}>
                            {showMendel ? 'Cancelar' : 'Sincronizar con Mendel'}
                        </button>
                    </>
                )}
            </div>
            {showMendel && isAdmin && (
                <form onSubmit={handleSincronizar} style={{
                    background: 'white', border: '1px solid #ddd', borderRadius: 8,
                    padding: '1.25rem', display: 'flex', gap: '0.75rem', alignItems: 'flex-end'
                }}>
                    <div style={{ flex: 1 }}>
                        <label style={{ fontSize: 12, color: '#666', display: 'block', marginBottom: 4 }}>
                            Token de Mendel
                        </label>
                        <input className="form-input" type="password" placeholder="Token Bearer de Mendel"
                            value={mendelToken} onChange={e => setMendelToken(e.target.value)} required />
                    </div>
                    <button type="submit" className="btn-primary">Sincronizar</button>
                    <button type="button" className="btn-secondary" onClick={() => setShowMendel(false)}>Cancelar</button>
                </form>
            )}
            {showForm && (
                <Form campos={campos} onSubmit={handleGuardar} onCancel={cerrarForm}
                    submitLabel={tarjetaForm.id ? 'Actualizar Tarjeta' : 'Crear Tarjeta'} />
            )}
            <Table columnas={columnas} datos={tarjetas} />
            <Modal modal={modal} setModal={setModal} />
            <ModalAsignar item={tarjetaAsignar} usuarios={usuarios} usuarioId={usuarioId} onChangeUsuario={setUsuarioId} onSubmit={handleAsignar} onClose={cerrarAsignar} />
            <ModalAsignacionesTarjeta tarjeta={tarjetaDetalle} asignaciones={asignaciones} onClose={cerrarDetalle} onDescargar={handleDescargar} onSubirFirmada={handleSubirFirmada} />
        </div>
    );
}